import { memo, useState, useEffect } from "react";
import PageWrapper from "js/Component/PageWrapper";
import PageTitle from "js/Component/PageTitle";
import PageInnerWrapper from "js/Component/PageInnerWrapper";
import FormManagement from "./tabs/FormManagement";
import TemplateManagement from "./tabs/TemplateManagement";
import FormDetails from "./FormDetails";

const FormContainer = (props) => {
    const { org } = props;

    const [activeTab, setActiveTab] = useState("forms");
    const [selectedForm, setSelectedForm] = useState(null);
    const [viewMode, setViewMode] = useState("list");

    const handleTabClick = (tab) => {
        setActiveTab(tab);

        setViewMode("list");
        setSelectedForm(null);
    };


    const handleFormRowClick = (form) => {
        setSelectedForm(form);
        setViewMode("details");
    };


    const handleBackToList = () => {
        setViewMode("list");
        setSelectedForm(null);
    };

    const handleFormCreated = (newForm) => {
        setSelectedForm(newForm);
        setViewMode("details");

        if (activeTab !== "forms") {
            setActiveTab("forms");
        }
    };

    const [EditTemplateItem, setEditTemplateItem] = useState(null);

    if (viewMode === "details" && selectedForm) {
        return (
            <PageWrapper>
                <FormDetails
                    selectedForm={selectedForm}
                    org={org}
                    handleBackClick={handleBackToList}
                />
            </PageWrapper>
        );
    }

    return (
        <PageWrapper>
            <PageTitle title="Forms" />
            <PageInnerWrapper>
                {/* Tab Navigation*/}
                <div className="tabbar" style={{ marginBottom: "20px" }}>
                    <nav>
                        <div
                            className="nav nav-tabs"
                            id="nav-tab"
                            role="tablist"
                        >
                            <div
                                className={`nav-item nav-link ${activeTab === "forms" ? "active" : ""}`}
                                onClick={() => handleTabClick("forms")}
                            >
                                Forms
                            </div>
                            <div
                                className={`nav-item nav-link ${activeTab === "templates" ? "active" : ""}`}
                                onClick={() => handleTabClick("templates")}
                            >
                                Templates
                            </div>
                        </div>
                    </nav>
                </div>

                {/* Tab Content */}
                <div>
                    {activeTab === "forms" && (
                        <FormManagement setActiveTab={setActiveTab} org={org} onRowClick={handleFormRowClick} onFormCreated={handleFormCreated} setEditTemplateItem={setEditTemplateItem} />
                    )}

                    {activeTab === "templates" && (
                        <TemplateManagement org={org} onRowClick={handleFormRowClick} onFormCreated={handleFormCreated}
                            EditTemplateItem={EditTemplateItem} setEditTemplateItem={setEditTemplateItem} />
                    )}
                </div>
            </PageInnerWrapper>
        </PageWrapper>
    );
};

export default memo(FormContainer);